export const translations = {
  id: {
    nav: { beranda: "Beranda", caraKerja: "Cara Kerja", layanan: "Layanan", inspector: "Inspector", harga: "Harga", tentangKami: "Tentang Kami", masuk: "Masuk", daftar: "Daftar", dashboard: "Dashboard" },
    vehicle: { bekas: "Mobil Bekas", listrik: "Mobil Listrik", truk: "Truk", moge: "Motor Moge" },
    hero: {
      t1: "Beli Mobil", t2: "Lebih", accent: "Aman", t3: "dengan Inspeksi", t4: "Profesional",
      desc: "Marketplace jasa inspector kendaraan terpercaya. Cek kondisi, hindari penipuan, dan ambil keputusan dengan percaya diri.",
      lokasi: "Lokasi", tanggal: "Tanggal Inspeksi", cari: "Cari Inspector",
      trust: [{ title: "Inspector", sub: "Terverifikasi" }, { title: "Laporan Detail", sub: "dan Objektif" }, { title: "Pembayaran Aman", sub: "(Escrow)" }, { title: "Tersedia di", sub: "Banyak Kota" }],
      hand1: "Mobil", hand2: "Bagus, Hidup", hand3: "Lebih Tenang", trusted: "Dipercaya Ribuan Pengguna",
    },
    services: {
      title: "Pilih Jenis Kendaraan", sub: "Dapatkan inspector yang sesuai dengan kebutuhan Anda.", link: "Lihat Semua Layanan",
      items: { bekas: "Inspeksi menyeluruh sebelum beli", listrik: "Cek baterai, sistem kelistrikan dan performa", truk: "Untuk kebutuhan bisnis yang lebih aman", moge: "Inspeksi detail untuk motor premium" },
    },
    how: {
      title: "Cara Kerja", accent: "Inspecar", sub: "Proses mudah, transparan, dan aman dari awal hingga selesai.", link: "Lihat Panduan Lengkap",
      steps: [
        { title: "Pilih Jenis Kendaraan", desc: "Tentukan jenis kendaraan dan lokasi inspeksi." },
        { title: "Pilih Inspector", desc: "Lihat profil, rating, harga, dan jadwal yang tersedia." },
        { title: "Booking & Bayar", desc: "Pesan jadwal dan lakukan pembayaran (escrow)." },
        { title: "Inspeksi & Laporan", desc: "Inspector datang, isi checklist dan submit laporan." },
        { title: "Selesai & Rating", desc: "Review laporan, dana diteruskan ke inspector, dan berikan rating." },
      ],
    },
    cta: {
      title1: "Keputusan Besar", title2: "Butuh Informasi yang Benar",
      desc: "Jangan ambil risiko. Gunakan jasa inspector profesional dan dapatkan laporan yang objektif dan terpercaya.",
      button: "Pesan Inspeksi Sekarang", points: ["Mobil Aman", "Transaksi Lancar", "Hindari Penipuan", "Hidup Lebih Tenang"],
      hand1: "Inspeksi", hand2: "Hari Ini,", hand3: "Tenang", hand4: "Esok Hari",
    },
    stats: { items: ["Pengguna Terdaftar", "Inspector Profesional", "Laporan Inspeksi", "Rating Pengguna"] },
    testi: {
      title: "Apa Kata Mereka?", sub: "Ribuan pengguna telah merasakan manfaat Inspecar.", link: "Lihat Semua Testimoni",
      items: [
        "Laporannya sangat detail dan membantu saya negosiasi harga. Sangat rekomendasi!",
        "Inspector datang tepat waktu dan sangat profesional. Prosesnya mudah dan aman.",
        "Berkat Inspecar, saya terhindar dari mobil bekas dengan masalah besar. Recommended!",
      ],
    },
    footer: { links: ["Beranda", "Layanan", "Inspector", "Harga", "Tentang Kami", "Bantuan"], copyright: "© 2026 Inspecar. All rights reserved." },
    inspectors: {
      heroCount: "Inspector Profesional", heroTitle2: "Siap Membantu Anda di Seluruh Indonesia",
      heroDesc: "Tim inspector independen kami telah diverifikasi dan berpengalaman dalam inspeksi mobil bekas, mobil listrik, truk, dan motor moge.",
      benefits: [{ title: "Inspector", sub: "Terverifikasi" }, { title: "Berpengalaman", sub: "dan Profesional" }, { title: "Rating Pengguna", sub: "Tinggi" }, { title: "Tersedia di", sub: "Banyak Kota" }],
      badgeJoin: "Lebih dari {count} Inspector", badgeJoinSub: "Bergabung Bersama Kami",
      hand: "Profesional Terpercaya Di Setiap Perjalanan",
      searchPlaceholder: "Cari inspector, nama atau kota...",
      jenisKendaraan: "Jenis Kendaraan", semua: "Semua", lokasi: "Lokasi", pilihKota: "Pilih Kota", urutkan: "Urutkan",
      sort: { rating: "Rating Tertinggi", price_low: "Harga Terendah", experience: "Pengalaman", reviews: "Ulasan Terbanyak", distance: "Terdekat" },
      lihatDiPeta: "Lihat di Peta", mapSoon: "Fitur peta segera hadir",
      listTitle: "Daftar Inspector", subtitle: "Pilih inspector profesional yang sesuai dengan kebutuhan Anda.",
      showing: "Menampilkan {from} - {to} dari {total} inspector",
      grid: "Grid", list: "List", mulaiDari: "Mulai dari", lihatProfil: "Lihat Profil",
      exp: "{n} tahun pengalaman", reviews: "{n} ulasan", inspeksiCount: "{n} inspeksi",
      badges: { top_rated: "Top Rated", pilihan_utama: "Pilihan Utama", tersedia: "Tersedia Hari Ini" },
      emptyTitle: "Tidak ada inspector yang cocok", emptyDesc: "Coba ubah filter jenis kendaraan atau kota.",
      ctaTitle1: "Bergabunglah", ctaTitle2: "Menjadi Inspector Inspecar",
      ctaDesc: "Tunjukkan keahlian Anda, dapatkan lebih banyak pelanggan, dan bangun reputasi profesional bersama Inspecar.",
      ctaButton: "Daftar Sekarang",
      ctaPoints: ["Akses ke ribuan pelanggan potensial", "Kelola jadwal secara fleksibel", "Pembayaran aman dan tepat waktu", "Bangun reputasi di seluruh Indonesia"],
      loginPrompt: "Silakan masuk untuk melanjutkan",
    },
  },
  en: {
    nav: { beranda: "Home", caraKerja: "How It Works", layanan: "Services", inspector: "Inspectors", harga: "Pricing", tentangKami: "About Us", masuk: "Sign In", daftar: "Register", dashboard: "Dashboard" },
    vehicle: { bekas: "Used Car", listrik: "Electric Car", truk: "Truck", moge: "Big Bike" },
    hero: {
      t1: "Buy a Car", t2: "More", accent: "Safely", t3: "with Professional", t4: "Inspection",
      desc: "A trusted vehicle inspector marketplace. Check the condition, avoid fraud, and make decisions with confidence.",
      lokasi: "Location", tanggal: "Inspection Date", cari: "Find Inspector",
      trust: [{ title: "Verified", sub: "Inspectors" }, { title: "Detailed", sub: "& Objective Reports" }, { title: "Secure Payment", sub: "(Escrow)" }, { title: "Available in", sub: "Many Cities" }],
      hand1: "Great Car,", hand2: "Peace of", hand3: "Mind", trusted: "Trusted by Thousands",
    },
    services: {
      title: "Choose Vehicle Type", sub: "Get an inspector that matches your needs.", link: "View All Services",
      items: { bekas: "Thorough inspection before you buy", listrik: "Check battery, electrical system and performance", truk: "For safer business needs", moge: "Detailed inspection for premium bikes" },
    },
    how: {
      title: "How", accent: "Inspecar Works", sub: "An easy, transparent, and safe process from start to finish.", link: "View Full Guide",
      steps: [
        { title: "Choose Vehicle Type", desc: "Set the vehicle type and inspection location." },
        { title: "Choose Inspector", desc: "See profiles, ratings, prices, and available schedules." },
        { title: "Book & Pay", desc: "Book a schedule and pay securely (escrow)." },
        { title: "Inspect & Report", desc: "The inspector arrives, fills the checklist and submits a report." },
        { title: "Done & Rate", desc: "Review the report, funds released to inspector, then leave a rating." },
      ],
    },
    cta: {
      title1: "Big Decisions", title2: "Need the Right Information",
      desc: "Don't take the risk. Use a professional inspector and get an objective, trustworthy report.",
      button: "Book an Inspection Now", points: ["Safe Car", "Smooth Transaction", "Avoid Fraud", "Peace of Mind"],
      hand1: "Inspect", hand2: "Today,", hand3: "Relax", hand4: "Tomorrow",
    },
    stats: { items: ["Registered Users", "Professional Inspectors", "Inspection Reports", "User Rating"] },
    testi: {
      title: "What They Say", sub: "Thousands of users have felt the benefits of Inspecar.", link: "View All Testimonials",
      items: [
        "The report was very detailed and helped me negotiate the price. Highly recommended!",
        "The inspector arrived on time and was very professional. The process was easy and safe.",
        "Thanks to Inspecar, I avoided a used car with major problems. Recommended!",
      ],
    },
    footer: { links: ["Home", "Services", "Inspectors", "Pricing", "About Us", "Help"], copyright: "© 2026 Inspecar. All rights reserved." },
    inspectors: {
      heroCount: "Professional Inspectors", heroTitle2: "Ready to Help You Across Indonesia",
      heroDesc: "Our independent inspector team is verified and experienced in inspecting used cars, electric cars, trucks, and big bikes.",
      benefits: [{ title: "Verified", sub: "Inspectors" }, { title: "Experienced", sub: "& Professional" }, { title: "High User", sub: "Rating" }, { title: "Available in", sub: "Many Cities" }],
      badgeJoin: "More than {count} Inspectors", badgeJoinSub: "Have Joined Us",
      hand: "Trusted Professionals On Every Journey",
      searchPlaceholder: "Search inspector, name or city...",
      jenisKendaraan: "Vehicle Type", semua: "All", lokasi: "Location", pilihKota: "Select City", urutkan: "Sort By",
      sort: { rating: "Highest Rating", price_low: "Lowest Price", experience: "Experience", reviews: "Most Reviews", distance: "Nearest" },
      lihatDiPeta: "View on Map", mapSoon: "Map feature coming soon",
      listTitle: "Inspector List", subtitle: "Choose a professional inspector that suits your needs.",
      showing: "Showing {from} - {to} of {total} inspectors",
      grid: "Grid", list: "List", mulaiDari: "Starting from", lihatProfil: "View Profile",
      exp: "{n} years experience", reviews: "{n} reviews", inspeksiCount: "{n} inspections",
      badges: { top_rated: "Top Rated", pilihan_utama: "Top Pick", tersedia: "Available Today" },
      emptyTitle: "No matching inspectors", emptyDesc: "Try changing the vehicle type or city filter.",
      ctaTitle1: "Join Us", ctaTitle2: "Become an Inspecar Inspector",
      ctaDesc: "Show your expertise, get more customers, and build a professional reputation with Inspecar.",
      ctaButton: "Register Now",
      ctaPoints: ["Access to thousands of potential customers", "Manage your schedule flexibly", "Safe and on-time payments", "Build your reputation across Indonesia"],
      loginPrompt: "Please sign in to continue",
    },
  },
};
